import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "vue-invitation__content",
  ref: "invitation"
}
const _hoisted_2 = { class: "vue-invitation__label" }
const _hoisted_3 = { class: "vue-invitation__info" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "vue-invitation__divider" }, null, -1)
const _hoisted_5 = { class: "vue-invitation__benefits" }
const _hoisted_6 = { class: "vue-invitation__benefits__benefit" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "icon-ok" }, null, -1)
const _hoisted_8 = { class: "vue-invitation__benefits__benefit" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "icon-ok" }, null, -1)
const _hoisted_10 = { class: "vue-invitation__benefits__benefit" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "icon-ok" }, null, -1)
const _hoisted_12 = { class: "vue-invitation__benefits__benefit" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "icon-ok" }, null, -1)
const _hoisted_14 = { class: "vue-invitation__link" }
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([{ visible: _ctx.isVisibleAnimation }, "vue-invitation"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", {
            class: "vue-invitation__close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          }),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('joinUs')), 1),
          _createElementVNode("span", _hoisted_3, [
            _createElementVNode("b", null, _toDisplayString(_ctx.$t('info1.'+ _ctx.shopId)), 1),
            _createTextVNode(_toDisplayString(_ctx.$t('info2.'+ _ctx.shopId)), 1)
          ]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.$t("benefits[0]")), 1)
            ]),
            _createElementVNode("span", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(_toDisplayString(_ctx.$t("benefits[1]")), 1)
            ]),
            _createElementVNode("span", _hoisted_10, [
              _hoisted_11,
              _createTextVNode(_toDisplayString(_ctx.$t("benefits[2]")), 1)
            ]),
            _createElementVNode("span", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(_toDisplayString(_ctx.$t("benefits[3]")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("a", {
              href: _ctx.$t('link'),
              role: "button",
              class: "dek-button-red"
            }, _toDisplayString(_ctx.$t('createAccount')), 9, _hoisted_15)
          ])
        ], 512)
      ], 2))
    : _createCommentVNode("", true)
}